// extracted by mini-css-extract-plugin
export default {"Page":"alerts_style_Page__oT57G","Content":"alerts_style_Content__PXBpJ","Skeleton":"alerts_style_Skeleton__AydzD"};